export function tooltipTitle(titles: { [title: string]: any }) {
    const [ title ] = Object.entries(titles).find(([ _, shouldShow ]) => shouldShow) || [];
    return title || '';
}
